import { useEffect, useState } from 'react';
import './style.scss';
import { CreateWebsiteSteps } from '../Components/CreateSystemConfigurationSteps/CreateSystemConfigurationSteps';
import { useGenerateFtpCredentials } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { Loading } from '@trufla-technology/trumarket-react-design-system';
import { GenerateFtpCredentialsResponse } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import useVerifyFtpCredentialsLogic from './hooks/useVerifyFtpCredentialsLogic';

import SiteCredentials from './Credentials';

export type props = {
  mode?: string;
};

export const FinalDetails = (props: props) => {
  const [ftp, setFTP] = useState<GenerateFtpCredentialsResponse['data']>();
  const generateFTP = useGenerateFtpCredentials();
  useEffect(() => {
    handleGenerate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGenerate = async () => {
    const { data } = await generateFTP({
      environments: ['development', 'staging', 'production'],
    });
    setFTP(data);
  };

  const { handleVerify, ftpCredentials } = useVerifyFtpCredentialsLogic();

  const { isVerified, isLoading, error, data } = ftpCredentials;

  return (
    <div className="site-details">
      <div className="form details">
        {<CreateWebsiteSteps step={3} disableFinish={isVerified} />}
        {!ftp ? (
          <div className="loading-wrapper">
            <Loading />
          </div>
        ) : (
          <SiteCredentials
            isVerified={isVerified}
            isLoading={isLoading}
            error={error}
            ftpData={ftp}
            handleVerify={handleVerify}
            ftpCredentials={data}
          />
        )}
      </div>
    </div>
  );
};
